/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClickHandler.bind(this));
    }
    onClickHandler(event) {
      event.preventDefault();
      const index = this.dataset.index;
      const key = this.dataset.key;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(key, '0', index);
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { key, index } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
